/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getPatientWrapper = /* GraphQL */ `
  query GetPatientWrapper {
    getPatientWrapper {
      patient {
        id
        email
        countryId
        firstName
        lastName
        dateOfBirth
        gender
        sleepTestType
        startTherapyGroup
        userEnteredAhi
        phoneNumber
        aboutMeProgress
        myEquipmentProgress
        myHealthProgress
        overallProgress
        achievementsPushEnabled
        coachingPushEnabled
        coachingSmsEnabled
        coachingEmailEnabled
        cleaningPushEnabled
        cleaningSmsEnabled
        cleaningEmailEnabled
        smartCoachingEnabled
        stepCountSharingEnabled
        healthSharingEnabled
        healthSharingLastPromptedVersion
        shareDetailsWithProviderOptIn
        analyticsMode
        analyticsId
        pushToken
        timezoneId
        furiganaFamilyName
        furiganaGivenName
        marketingOptIn
        achievements {
          id
          name
          description
          imageUrl
          earnedDate
        }
        journeys
        firstTherapySessionDate
        lifetimeUsageHours
        processHealthDataOptIn
        streaksEnabled
        streaksPushEnabled
        announcementsPushEnabled
        accountCreationTime
        equipmentReplacementPushEnabled
        equipmentResupplyPushEnabled
        equipmentManagementEnabled
        heightInCentimeters
        heightInCm
        weightInKilograms
        weightInKg
        goalTrackingCompleted
      }
      fgDevices {
        serialNumber
        # deviceType
        deviceSeries
        deviceFamily
        lastSleepDataReportTime
        localizedName
        imagePath
        imageUrl
        fgDeviceManufacturerName
        fgDevicePatientId
        deviceSubtype
        manufacturer
        ptcsInfo {
          isEnabled
          firstEnabledDate
        }
      }
      masks {
        maskManufacturerName
        maskCode
        maskType
        localizedName
        imagePath
        imageUrl
        maskPatientId
        cushionType
        manufacturer
        cushionMaterial
      }
      coachingHistory {
        items {
          date
          sleepLibraryId
          smartCoachingId
        }
        lastEvaluatedKey
      }
      sleepLibrary {
        title
        thumbnail
        description
        videoOrHtmlUrl
        contentId
        language
        sleepLibraryId
        section
        type
        sleepLibraryPatientId
        analyticsScreenName
        videoId
      }
      equipmentCareCoachingContent {
        title
        thumbnail
        description
        videoOrHtmlUrl
        contentId
        language
        sleepLibraryId
        section
        type
        sleepLibraryPatientId
        analyticsScreenName
        videoId
      }
      sleepRecords {
        items {
          startDate
          totalUsage
          sleepScore
          usageScore
          ahiScore
          maskScore
          leakScore
          ahi
          maskPairCount
          leakPercentile
          sleepRecordPatientId
        }
        lastEvaluatedKey
      }
      notifications {
        id
        action
        title
        description
        positiveButtonTitle
        negativeButtonTitle
        url
        imageUrl
        negativeActionId
        negativeActionContent {
          title
          description
          positiveButtonTitle
          negativeButtonTitle
        }
        achievement {
          id
          name
          description
          imageUrl
          earnedDate
        }
      }
      dashboard {
        sectionsV1 {
          sectionType
        }
        sectionsV2 {
          sectionType
        }
        sectionsV3 {
          sectionType
        }
        sectionsV4 {
          sectionType
        }
      }
      healthTrends {
        usage {
          previousAverage
          currentAverage
          trend
        }
        stepCount {
          previousAverage
          currentAverage
          trend
        }
        weightKilograms {
          previousAverage
          currentAverage
          trend
        }
        activeCaloriesBurned {
          previousAverage
          currentAverage
          trend
        }
        bloodOxygenPercent {
          previousAverage
          currentAverage
          trend
        }
        bodyMassIndex {
          previousAverage
          currentAverage
          trend
        }
        heartRateVariabilityMilliseconds {
          previousAverage
          currentAverage
          trend
        }
        restingHeartRate {
          previousAverage
          currentAverage
          trend
        }
        timeInBedMinutes {
          previousAverage
          currentAverage
          trend
        }
        totalTimeAsleepMinutes {
          previousAverage
          currentAverage
          trend
        }
        exerciseMinutes {
          previousAverage
          currentAverage
          trend
        }
        maskSeal {
          previousAverage
          currentAverage
          trend
        }
        ahi {
          previousAverage
          currentAverage
          trend
        }
        maskOnOffCount {
          previousAverage
          currentAverage
          trend
        }
        sleepScore {
          previousAverage
          currentAverage
          trend
        }
        restorativeSleep {
          previousAverage
          currentAverage
          trend
        }
      }
      achievements {
        id
        name
        description
        imageUrl
        earnedDate
      }
      goalTrackingDates {
        goalPeriodStartDate
        goalPeriodEndDate
      }
      sleepTests {
        id
        isActive
        minRecordingTimeInSeconds
      }
      cciTherapyResponse {
        cciSurveys {
          dateTime
        }
      }
      sleepSummary {
        date
        totalTimeAsleepMinutes
        totalTimeInBedMinutes
        totalUsageHours
        sleepSessions {
          startTime
          endTime
          timeAsleepSeconds
          durationSeconds
        }
      }
      consents {
        consentType
        consentStatus
        consentCreationTime
        consentExpirationTime
        consentUrl
      }
      narrativeScreens {
        analyticsId
        backgroundImage {
          url
          anchorPoint
        }
        layout
        content {
          title
          subtitle
          callout
        }
        showPagingIndicator
      }
      ptcsInfo {
        isEnabled
        firstEnabledDate
        recommendation {
          autoSetComfort
          rampEnable
          rampTime
          eprEnable
          eprType
          eprPressure
        }
        revertSettings {
          autoSetComfort
          rampEnable
          rampTime
          eprEnable
          eprType
          eprPressure
        }
      }
      streakDetails {
        currentStreakLength
        currentStreakStartDate
        currentStreakEndDate
        isFromPreviousMonth
        longestStreakLength
        freezeDaysRemaining
        freezeDaysMax
        streakUnqualifiedDays {
          date
          type
        }
        lastWeekQualifyingDays
        thisWeekQualifyingDays
        isMilestoneDay
      }
      resupplyInfo {
        dueDate
        totalDays
        hmeInfo {
          id
          name
          phoneNumber
          email
          websiteUrl
          imageUrl
        }
      }
      dailyTherapyData {
        date
        ahi
        totalUsageHours
        totalSecondsInApnea
        respiratoryEvents {
          startDate
          endDate
          durationSeconds
          eventType
        }
        therapyStatusEvents {
          date
          eventType
        }
      }
      insurance {
        name
        planName
        policyGroupId
        policyHolderFirstName
        policyHolderLastName
      }
      provider {
        name
        phone
        contactInfo
        addressForReturns
        customerServiceEmail
        website
      }
      rapidOrder {
        rapidOrderKey
        patientKey
        patientFirstName
        patientLastName
        patientEmailAddress
        patientBillingAddress {
          street1
          street2
          city
          postalCode
        }
        items {
          itemKey
          itemDescription
          qty
          eligibilityDrivingHcpcForItem
        }
        productLineQuestions {
          productLineQuestionKey
          productLineQuestionDataType
          productLineQuestionName
          productLineQuestionText
          sortOrder
          isRequiredBeforeBooking
          isRequiredEvenAfterBooking
          isRequiredForMedicareOnly
          mustBeYesGroupName
          mustBeNoGroupName
          answerChoices
        }
      }
      orderStatus {
        key
        id
        currentStatus
        currentStatusSince
        workflowState
        workflowStateSince
        documentsNeeded
        preshipIssues
        createdDate
        bookedDate
        sentToShipperDate
        shippedDate
        pickedUpDate
        sentToBillingDate
        voidedDate
        writtenOffDate
        completedDate
        items {
          itemKey
          itemName
          itemDescription
          qty
        }
        shippingAddress {
          street1
          street2
          city
          postalCode
        }
        shippingCarrier
        shippingTrackingNumber
        shippingTrackingNumberUrl
      }
      orderHistory {
        key
        id
        currentStatus
        currentStatusSince
        workflowState
        workflowStateSince
        documentsNeeded
        preshipIssues
        createdDate
        bookedDate
        sentToShipperDate
        shippedDate
        pickedUpDate
        sentToBillingDate
        voidedDate
        writtenOffDate
        completedDate
        items {
          itemKey
          itemName
          itemDescription
          qty
        }
        shippingAddress {
          street1
          street2
          city
          postalCode
        }
        shippingCarrier
        shippingTrackingNumber
        shippingTrackingNumberUrl
      }
      salesDialer {
        patientKey
        daysUntilPatientCanReorder
        isEligibleForReorder
      }
      snapPatient {
        patientKey
        firstName
        lastName
        suffix
        emailAddress
        dateOfBirth
      }
    }
  }
`;
export const getFeatureMetadata = /* GraphQL */ `
  query GetFeatureMetadata {
    getFeatureMetadata {
      dawn {
        enabled
        myTherapyNavigatorEnabled
        url
      }
      deviceControl {
        enabled
        version
      }
      myAirDirect {
        enabled
      }
      streaks {
        enabled
      }
      equipmentManagement {
        enabled
        scheduleConfig {
          ... on FgEquipmentReplacementScheduleConfigItem {
            recommendedRecurrenceDays
            minRecurrenceDays
            maxRecurrenceDays
          }
          ... on MaskEquipmentReplacementScheduleConfigItem {
            cushionType
            cushionMaterial
            recommendedRecurrenceDays
            minRecurrenceDays
            maxRecurrenceDays
          }
          ... on ResupplyScheduleConfigItem {
            recommendedRecurrenceDays
            minRecurrenceDays
            maxRecurrenceDays
          }
        }
        marketType
      }
      coaching {
        smartCoachingEnabled
      }
      support {
        showAdaLabel
      }
      mask {
        showMaskMagneticEducationalMaterials
      }
      achievements {
        enabled
      }
      userInfo {
        papTherapyOnboardingQuestionsEnabled
      }
      appWidget {
        enabled
      }
      watch {
        enabled
      }
      sleepRecord {
        scoreEnabled
      }
      consent {
        isRevokeConsentVisible
        isUpdateConsentVisible
        isFaqContentVisible
      }
      dataExperience {
        timelineEnabled
      }
      sleepTest {
        enabled
      }
    }
  }
`;
export const getMaskQuestions = /* GraphQL */ `
  query GetMaskQuestions($maskCode: String!, $locale: String!) {
    getMaskQuestions(maskCode: $maskCode, locale: $locale) {
      questionId
      localizedQuestion
      answers {
        answerId
        localizedAnswer
      }
    }
  }
`;
